var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:leaf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 837",
    d: "M10.6936 9.59069C7.68318 10.8809 6.10632 15.8982 5.96297 17.3317C5.58032 16.9016 3.4868 14.6315 3.09383 13.4612C2.78772 12.5496 3.09383 9.59072 6.1042 7.87051C9.11458 6.1503 15.4241 5.72021 18.4345 5.29016C20.8428 4.94612 20.5848 4.86011 21.4449 4C20.726 5.72021 20.1547 7.01034 18.4345 7.87048C16.1916 8.99195 14.564 7.93192 10.6936 9.59069Z",
    fill: "#202E5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 836",
    d: "M7.25342 20.342L5.5332 19.912C6.39331 17.7617 7.68347 13.4612 9.83374 11.3109C12.1614 8.98326 13.4141 9.25736 17.5747 7.87048C20.155 7.01037 20.7284 5.43351 21.4452 4C20.8718 7.44043 17.474 14.9932 14.1343 16.9016C11.1239 18.6218 9.40368 18.6218 8.11352 18.1918L7.25342 20.342Z",
    fill: "#E3E4E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e6e92c7bbfdf035656f06996873d5145.svg";
export { ForwardRef as ReactComponent };